import {useEffect, useState} from "react";
import {Redirect} from "react-router-dom";
import {getApplicationState, setApplicationState} from "../../services/common";
import {genRandomString} from "@okta/okta-auth-js";
import {getGoogleAuthorizeUrl} from "../../services/api/socialIdentityApi";

const GoogleRedirect = () => {
	const [completed, setCompleted] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				const appState = getApplicationState();
				if(!('google' in appState)) {
					appState.google = {};
				}

				appState.google.state = genRandomString(32);

				setApplicationState(appState);

				const response = await getGoogleAuthorizeUrl(appState.google.state);

				if (!response?.data?.data) {
					setCompleted(true);
					return;
				}

				window.location.href = response.data.data;
			}
			catch(_) {
				setCompleted(true);
			}
		})();
	}, []);

	if(completed) {
		return (<Redirect to={'/'} />);
	}

	return (<></>);
}

export default GoogleRedirect;
